
import formAPIInventoryLogs from "./log";


var formattedOutput = null;

const formAPIModelinventoryLogs = (data) => {
  // Apply formAPIModel to each item in the data array
  formattedOutput = data.map(item => formAPIInventoryLogs(item));


  return formattedOutput
};

export default formAPIModelinventoryLogs